import type { ChangeEvent } from 'react';
import { useRef } from 'react';

import { Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import CameraSVG from 'public/camera.svg';
import { Card, CardItem } from 'src/app/components/Elements/Card';

import { TransparentButton } from '../../Elements/Button/TransparentButton';

import styles from './styles.module.scss';

export const StyledCamera = styled(InlineSVG)`
  display: block;
  height: 21px;
  width: 22px;
  & svg,
  & svg > path {
    color: ${({ theme }) => theme.colors.capsuleBlue50};
    fill: ${({ theme }) => theme.colors.capsuleBlue50};
  }
  margin: auto;
`;

const ImageIconContainer = styled.div`
  border-radius: 50%;
  background-color: ${props => props.theme.colors.capsuleGreen10};
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-items: center;
  margin-right: ${props => props.theme.space.s3};
`;

const UploadCardItem = styled(CardItem)`
  display: flex !important;
  flex-direction: row;
  align-items: center;
  padding: ${props => props.theme.space.s1} !important;
`;

const UploadButton = styled(TransparentButton)`
  width: 100%;
`;

const BlueBodyText = styled(Typography)`
  color: ${props => props.theme.colors.capsuleBlue50};
`;

interface UploadImageProps {
  name: string;
  handleFileUpload: (event: ChangeEvent<HTMLInputElement>, cardType: string) => void;
  bodyText: string;
}
export const UploadImage = ({ name, handleFileUpload, bodyText }: UploadImageProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClickCapture = (event: ChangeEvent<HTMLButtonElement>) => {
    event.preventDefault();
    // This prompts the user with a file browser/take a photo
    inputRef?.current?.click();
  };

  return (
    <Card className={styles.component}>
      <UploadButton onClick={handleClickCapture}>
        <UploadCardItem>
          <ImageIconContainer>
            <StyledCamera src={CameraSVG} />
          </ImageIconContainer>
          <BlueBodyText variant={'body'}>{bodyText}</BlueBodyText>
        </UploadCardItem>
      </UploadButton>
      <input
        name={name}
        className={styles.hideInput}
        onChange={handleFileUpload}
        accept="image/*"
        type="file"
        ref={inputRef}
        id={`${name}_upload_image`}
      />
    </Card>
  );
};
